export default "__VITE_ASSET__f2326ae1__"